import { IProject, IUserToken } from "@/interfaces";

export const calculateIsUserProjectTeamMember = (
  projectLoading: boolean,
  project: IProject,
  { user: { id } }: IUserToken
): boolean => {
  if (projectLoading || !project || !id) return false;

  if (project.projectMembers)
    return Object.values(project.projectMembers).includes(id);

  return project.requestor === id;
};
